export const rootSelector = (state) => state.embed || {};
